export default "__VITE_ASSET__UBLsKuVb__"